import { createVanIconComponent } from "./van"

const Expand = createVanIconComponent("expand")
export default Expand
